/**
 * Sets the progress bar position based on the active step's offset.
 * Reads data-orientation to determine whether to measure inline (horizontal) or block (vertical).
 */
const updateProgress = (stepper) => {
  const orientation = stepper.dataset.orientation;

  const active = stepper?.querySelector( '[aria-current="step"]' ) || false;

  if (!active) {
    return;
  }

  switch (orientation) {
    case 'vertical':
      const dotBlock = active.getBoundingClientRect().top - stepper.getBoundingClientRect().top;
      stepper.style.setProperty( '--denhaag-project-hero-progress', dotBlock + 'px' );
      break;
    case 'horizontal':
    default:
      const dotInline = active.getBoundingClientRect().left - stepper.offsetLeft;
      stepper.style.setProperty( '--denhaag-project-hero-progress', dotInline + 'px' );
      break;
  }
}

/**
 * Switches a horizontal stepper to vertical when its content overflows.
 * Stores the original orientation once so only horizontal steppers are candidates for flipping.
 */
const checkOrientation = (stepper) => {
  // Persist the authored orientation so we only ever flip horizontal → vertical.
  if (stepper.dataset.originalOrientation === undefined) {
    stepper.dataset.originalOrientation = stepper.dataset.orientation || 'horizontal';
  }

  // Steppers that were originally vertical should stay vertical.
  if (stepper.dataset.originalOrientation !== 'horizontal') {
    return;
  }

  // Reset to horizontal first so scrollWidth is measured without the vertical layout.
  stepper.dataset.orientation = 'horizontal';
  stepper.dataset.orientation = stepper.scrollWidth > stepper.clientWidth ? 'vertical' : 'horizontal';
}

/**
 * Initialises all project-hero steppers: first resolves orientation, then positions the progress bar.
 * Called on DOMContentLoaded and on every debounced resize (dh:resize).
 */
const initSteppers = () => {
  document.querySelectorAll( '.denhaag-project-hero__steps' )?.forEach( (el) => {
    checkOrientation( el );
    updateProgress( el );
  } );
}

window.addEventListener( 'DOMContentLoaded', initSteppers );
window.addEventListener( 'dh:resize', initSteppers ); // Fires on resize and orientationChange.
